<div class="main-content profile-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>Editar Perfil</h1>
        <p>Actualice el nombre, el sitio y los permisos asociados al perfil seleccionado.</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" mat-raised-button class="btn profile-editor-page__secondary-btn" (click)="back()">
          Cancelar
        </button>
        <button type="button" mat-raised-button class="btn profile-editor-page__primary-btn" (click)="Modificar()">
          Guardar Cambios
        </button>
      </div>
    </section>

    <div class="row profile-editor-page__layout">
      <div class="col-lg-4 col-md-12">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">manage_accounts</i>
              <span>Datos del Perfil</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <mat-form-field appearance="outline" class="profile-editor-page__field">
              <mat-label>Nombre del perfil</mat-label>
              <input matInput type="text" name="nombre" [(ngModel)]="nombre" id="nombre" aria-label="Nombre del perfil" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="profile-editor-page__field">
              <mat-label>Sitio</mat-label>
              <mat-select [(ngModel)]="selectedValue" (selectionChange)="capturar($event.value)" id="sitio" name="sitio">
                <mat-option *ngFor="let sitios of sitioperfil" [value]="sitios.nombre">
                  {{ sitios.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>

        <section class="profile-editor-page__card profile-editor-page__card--summary">
          <div class="profile-editor-page__card-header">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">fact_check</i>
              <span>Resumen</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body profile-editor-page__summary-list">
            <div class="profile-editor-page__summary-item">
              <span>ID de perfil</span>
              <strong>#{{ numero || idperfil }}</strong>
            </div>
            <div class="profile-editor-page__summary-item">
              <span>Sitio actual</span>
              <strong>{{ selectedValue || 'Sin seleccionar' }}</strong>
            </div>
            <div class="profile-editor-page__summary-item">
              <span>Menús marcados</span>
              <strong>{{ selectedMenusCount }}</strong>
            </div>
          </div>
        </section>
      </div>

      <div class="col-lg-8 col-md-12">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header profile-editor-page__card-header--tree">
            <div class="profile-editor-page__card-title">
              <i class="material-icons">account_tree</i>
              <span>Permisos y Menús</span>
            </div>

            <div class="profile-editor-page__tree-meta" *ngIf="selectedValue">
              <span class="profile-editor-page__chip">{{ selectedValue }}</span>
              <span class="profile-editor-page__counter">{{ selectedMenusCount }} seleccionados</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <ng-container *ngIf="selectedValue; else profileTreePlaceholder">
              <div class="profile-editor-page__tree-wrap" *ngIf="!loadingMenus; else profileTreeLoading">
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                    <button mat-icon-button disabled></button>
                    <mat-checkbox class="profile-editor-page__tree-check" [checked]="checklistSelection.isSelected(node)"
                      (change)="todoLeafItemSelectionToggle(node)">
                      {{ node.nombre }}
                    </mat-checkbox>
                  </mat-tree-node>

                  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nombre">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                    </button>
                    <mat-checkbox class="profile-editor-page__tree-check"
                      [indeterminate]="descendantsPartiallySelected(node)"
                      [checked]="descendantsAllSelected(node)"
                      (change)="todoItemSelectionToggle(node)">
                      {{ node.nombre }}
                    </mat-checkbox>
                  </mat-tree-node>
                </mat-tree>
              </div>
            </ng-container>

            <ng-template #profileTreeLoading>
              <div class="profile-editor-page__empty-state profile-editor-page__empty-state--loading">
                <i class="material-icons">hourglass_top</i>
                <strong>Cargando menús del perfil...</strong>
              </div>
            </ng-template>

            <ng-template #profileTreePlaceholder>
              <div class="profile-editor-page__empty-state">
                <i class="material-icons">web</i>
                <strong>Selecciona un sitio para cargar los permisos</strong>
                <span>Al cambiar de sitio se reiniciará la selección para reflejar la estructura correcta.</span>
              </div>
            </ng-template>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
